import "../css/companycard.css";
import React from "react";

const CompanyCard = ({
  leftImage,
  rightIcon,
  companyName,
  tag,
  functionalCurrency,
  min = false,
}) => {
  return (
    <div className={`${min ? "min-company-card" : "company-card"}`}>
      <div className="company-card-image left-image">
        {/* <img src={leftImage} alt="Left" /> */}
        {leftImage}
      </div>
      <div className="card-content">
        <span className="company-label">
          {companyName ? (
            companyName?.length > 16 ? (
              <div class="rtooltip">
                {companyName.substring(0, 14).concat("...")}
                <span class="rtooltiptext" style={{ width: "185px" }}>
                  {companyName}
                </span>
              </div>
            ) : (
              companyName
            )
          ) : (
            companyName
          )}
        </span>
        <span>{tag}</span>
        <span>
          <span className="currency-label">Currency </span>
          <span className="currency-val">{functionalCurrency || "N/A"}</span>
        </span>
      </div>
      <span className="right-icon">{rightIcon}</span>
    </div>
  );
};

export default CompanyCard;
